import React from "react";
import Banner1 from "../components/homepage/Banner1";
import Portfolio from "../components/homepage/Portfolio";
import Benefits from "../components/homepage/Benefits";
import Classes from "../components/homepage/Classes";
import ContactForm from "../components/homepage/ContactForm";
// import Footer from "../components/homepage/Footer";

const HomePage = () => {
  return (
    <div>
      <Banner1 />
      <Portfolio />
      <Benefits />
      <Classes />
      <ContactForm />
      {/* <Footer /> */}
    </div>
  );
};

export default HomePage;
